<template>
    <div class="showMap">
        <div id="containerMap"></div>
        <div class="address">
            <div>
                <span class="label">当前位置：</span>
                <span class="value">{{ addressObj.address }}</span>
                <span class="label">当前经纬度：</span>
                <span class="value"
                    >{{ addressObj.lng }} , {{ addressObj.lat }}</span
                >
            </div>
            <div style="width：100%;    text-align: center;margin-top: 20px;">
                <el-button
                    style="marginleft: 20px"
                    type="primary"
                    @click="submit"
                    >确定</el-button
                >
            </div>
        </div>
        <div class="inputBox">
            <!-- <CitySelectCom
                ref="cityNo"
                :IsAll="true"
                v-model="cityName"
            ></CitySelectCom> -->
            <el-input
                style="width: 300px; margin: 0 2px"
                id="pickerInput"
                clearable
                placeholder="输入关键字选取地点"
                v-model="inputAdd"
            >
            </el-input>
            <el-button type="primary" @click="getLng(inputAdd, false)"
                >搜索</el-button
            >
        </div>
        <div class="LabelBox">
            <div class="addressIcon" @click="GaodeMap()">
                <i class="el-icon-map-location"></i>
            </div>
            <div
                :class="['addressIcon', zoomIndex >= 18 ? 'UnShow' : null]"
                @click="getAmplification"
            >
                <i class="el-icon-plus"></i>
            </div>
            <div
                :class="['addressIcon', zoomIndex <= 4 ? 'UnShow' : null]"
                @click="getNarrow"
            >
                <i class="el-icon-minus"></i>
            </div>
        </div>
    </div>
</template>

<script>
import CitySelectCom from "@/components/map/CitySelectCom";
export default {
    name: "showMap",
    components: {
        CitySelectCom,
    },
    data() {
        return {
            cityNo: "",
            cityName: "成都",
            zoomIndex: 12,
            poiPicker: null,
            InfoWindow: null,
            icon: null,
            inputAdd: "",
            IsShowMap: false,
            mapAMap: null,
            geocoder: null,
            markerMap: null,
            addressObj: {
                address: "",
                lng: 116.418481,
                lat: 39.90833,
            },
            PriData: {
                province: "",
                city: "",
                district: "",
            },
            PriArray: [],
            UiContent: null,
        };
    },
    props: {
        type: {
            type: Number, // 1 商品列表 2 商品详情
        },
        positionAddress: {},
        mapData: {
            type: Object,
            default() {
                return {
                    address: "",
                    distance: "",
                    lon: "",
                    lat: "",
                };
            },
        },
    },
    computed: {
        // allArea: function() {
        //   return this.$store.state.globalAllArea;
        // }
        position() {
            return this.$store.state.position;
        },
    },
    created() {},
    mounted() {
        this.GaodeMap();
    },

    methods: {
        //确定
        submit() {
            const obj = {
                point: {
                    lng: this.addressObj.lng,
                    lat: this.addressObj.lat,
                },
                value: this.addressObj.address,
            };
            const array = [];
            array.push(this.addressObj.lng);
            array.push(this.addressObj.lat);

            this.$emit("setPosition", obj, array);
            this.$emit("close");
        },
        changAddress(obj) {},
        //地理转换
        getLng(value, type) {
            var that = this;
            if (type) {
                //选择城市
                if (value == "全国" || !this.geocoder) {
                    return;
                }
                const addressQ = `${value}市人民政府`;
                if (this.markerMap) {
                    this.mapAMap.remove(this.markerMap);
                }
                this.geocoder.getLocation(addressQ, function (status, result) {
                    if (status === "complete" && result.geocodes.length) {
                        that.addressObj.address =
                            result.geocodes[0].formattedAddress;
                        that.addressObj.lng = result.geocodes[0].location.lng;
                        that.addressObj.lat = result.geocodes[0].location.lat;
                        that.PriData.province =
                            result.geocodes[0].addressComponent.province;
                        that.PriData.city =
                            result.geocodes[0].addressComponent.city;
                        that.PriData.district =
                            result.geocodes[0].addressComponent.district;
                        that.setCenter();
                    } else {
                        that.$message.error("根据地址查询经纬度失败");
                    }
                });
            } else {
                //点击搜索
                if (!value) {
                    that.$message.error("请输入关键字选取地点");
                    return;
                }
                if (this.markerMap) {
                    this.mapAMap.remove(this.markerMap);
                }
                const cityW = `${this.cityName}市${value}`;
                this.geocoder.getLocation(cityW, function (status, result) {
                    if (status === "complete" && result.geocodes.length) {
                        that.addressObj.address =
                            result.geocodes[0].formattedAddress;
                        that.addressObj.lng = result.geocodes[0].location.lng;
                        that.addressObj.lat = result.geocodes[0].location.lat;
                        that.PriData.province =
                            result.geocodes[0].addressComponent.province;
                        that.PriData.city =
                            result.geocodes[0].addressComponent.city;
                        that.PriData.district =
                            result.geocodes[0].addressComponent.district;

                        that.setCenter();
                    } else {
                        that.$message.error("根据地址查询经纬度失败");
                    }
                });
            }
        },
        //设置中心点
        setCenter() {
            var that = this;
            that.mapAMap.setCenter([that.addressObj.lng, that.addressObj.lat]);
            that.markerMap = new AMap.Marker({
                icon: that.icon,
                offset: new AMap.Pixel(-9, -3),
                // offset: new AMap.Pixel(-17, -20),
                position: new AMap.LngLat(
                    that.addressObj.lng,
                    that.addressObj.lat
                ),
            });
            that.mapAMap.add(that.markerMap);
            that.infoWindow = new AMap.InfoWindow({
                content: that.addressObj.address, //传入 dom 对象，或者 html 字符串
            });
            that.infoWindow.open(
                that.mapAMap,
                new AMap.LngLat(that.addressObj.lng, that.addressObj.lat)
            );
        },
        //缩小
        getNarrow() {
            if (this.zoomIndex > 4) {
                this.zoomIndex = this.zoomIndex - 1;
                this.mapAMap.setZoom(this.zoomIndex);
            }
        },
        //放大
        getAmplification() {
            if (this.zoomIndex < 18) {
                this.zoomIndex = this.zoomIndex + 1;
                this.mapAMap.setZoom(this.zoomIndex);
            }
        },
        //初始化高德地图
        GaodeMap() {
            var that = this;
            // that.cityName=""
            this.mapAMap = new AMap.Map("containerMap", {
                resizeEnable: true,
                showIndoorMap: false, //关闭室内地图
                zoom: 12,
            });
            that.icon = new AMap.Icon({
                size: new AMap.Size(32, 42), // 图标尺寸
                image: require("../../assets/map-point.png"), // Icon的图像
                imageOffset: new AMap.Pixel(2, 2), // 图像相对展示区域的偏移量，适于雪碧图等
                imageSize: new AMap.Size(15, 17), // 根据所设置的大小拉伸或压缩图片
            });
            // this.geocoder = new AMap.Geocoder({});
            AMap.plugin("AMap.Geocoder", function () {
                that.geocoder = new AMap.Geocoder({
                    // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                });
            });
            AMap.plugin("AMap.Geolocation", function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 10000, //超过10秒后停止定位，默认：5s
                    buttonPosition: "RB", //定位按钮的停靠位置
                    buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
                    showButton: false,
                    markerOptions: {
                        //自定义定位点样式，同Marker的Options
                        offset: new AMap.Pixel(-18, -36),
                        content:
                            '<img src="https://a.amap.com/jsapi_demos/static/resource/img/user.png" style="width:36px;height:36px"/>',
                    },
                    circleOptions: {
                        //定位精度圈的样式
                        strokeColor: "#0093FF",
                        noSelect: true,
                        strokeOpacity: 0.5,
                        strokeWeight: 1,
                        fillColor: "#02B0FF",
                        fillOpacity: 0.25,
                    },
                });
                that.mapAMap.addControl(geolocation);
                if (that.position.lng && that.position.lat) {
                    that.mapAMap.setZoomAndCenter(12, [
                        that.position.lng,
                        that.position.lat,
                    ]);
                    that.cityName = that.position.address.city
                        ? that.position.address.city.slice(
                              0,
                              that.position.address.city.length - 1
                          )
                        : "";
                    that.addressObj.lng = that.position.lng;
                    that.addressObj.lat = that.position.lat;
                    that.regeoCode();
                    that.setAddress(that.cityName);
                } else {
                    geolocation.getCurrentPosition(function (status, result) {
                        if (status == "complete") {
                            //获得成功
                            that.mapAMap.setZoomAndCenter(12, [
                                result.position.lng,
                                result.position.lat,
                            ]);
                            that.cityName = result.addressComponent.city
                                ? result.addressComponent.city.slice(
                                      0,
                                      result.addressComponent.city.length - 1
                                  )
                                : "";
                            that.addressObj.lng = result.position.lng;
                            that.addressObj.lat = result.position.lat;
                            that.regeoCode();
                            that.setAddress(that.cityName);
                        } else {
                            //获得失败
                            console.log("定位失败");
                        }
                    });
                }
            });
            this.mapAMap.on("click", function (e) {
                that.addressObj.lng = e.lnglat.lng;
                that.addressObj.lat = e.lnglat.lat;
                if (that.infoWindow) {
                    // that.infoWindow.close(that.mapAMap);
                }
                that.regeoCode();
            });

            // 样式
            // that.setAddress();
            // AMapUI.loadUI(["misc/PoiPicker"], function(PoiPicker) {
            //   that.poiPicker = new PoiPicker({
            //     city: that.cityName,
            //     input: "pickerInput"
            //   });
            //   //初始化poiPicker
            //   that.poiPickerReady(that.poiPicker);
            // });
        },
        //查询地址
        regeoCode() {
            if (this.markerMap) {
                this.mapAMap.remove(this.markerMap);
            }
            var that = this;
            this.geocoder.getAddress(
                [that.addressObj.lng, that.addressObj.lat],
                function (status, result) {
                    if (status === "complete" && result.regeocode) {
                        that.addressObj.address =
                            result.regeocode.formattedAddress;
                        that.PriData.province =
                            result.regeocode.addressComponent.province;
                        that.PriData.city =
                            result.regeocode.addressComponent.city;
                        that.PriData.district =
                            result.regeocode.addressComponent.district;
                    } else {
                        that.$message.error("根据经纬度查询地址失败");
                    }
                    that.setCenter();
                }
            );
        },
        //设置地点
        setAddress(city) {
            var that = this;
            if (that.UiContent) {
                this.poiPicker.setCity(city);
                that.poiPickerReady(that.poiPicker);
            } else {
                //   样式;
                AMapUI.loadUI(["misc/PoiPicker"], function (PoiPicker) {
                    that.UiContent = PoiPicker;
                    that.poiPicker = new PoiPicker({
                        city: city,
                        input: "pickerInput",
                    });
                    //初始化poiPicker
                    that.poiPickerReady(that.poiPicker);
                });
            }
        },
        //
        poiPickerReady(poiPicker) {
            var that = this;
            //选取了某个POI
            poiPicker.on("poiPicked", function (poiResult) {
                if (poiResult.source == "suggest") {
                    const addressT = `${poiResult.item.district}${poiResult.item.address}${poiResult.item.name}`;
                    // that.inputAdd = poiResult.item.name;
                    that.addressObj.address = addressT;
                    that.addressObj.lng = poiResult.item.location.lng;
                    that.addressObj.lat = poiResult.item.location.lat;
                } else if (poiResult.source == "search") {
                    const addressT = `${poiResult.item.pname}${poiResult.item.cityname}${poiResult.item.adname}${poiResult.item.address}${poiResult.item.name}`;
                    // that.inputAdd = poiResult.item.name;
                    that.addressObj.address = addressT;
                    that.addressObj.lng = poiResult.item.location.lng;
                    that.addressObj.lat = poiResult.item.location.lat;
                }
                // that.setCenter();
                that.regeoCode();
            });
            poiPicker.onCityReady(function (res) {
                if (that.inputAdd) {
                    poiPicker.suggest(that.inputAdd);
                }
            });
        },
    },
    watch: {
        cityName: {
            handler(nVal) {
                if (nVal) {
                    // this.inputAdd =""
                    this.getLng(nVal, true);
                    this.setAddress(nVal);
                }
            },
            immediate: true,
            deep: true,
        },
    },
    mixins: [],
    filters: {},
};
</script>

<style lang="scss" scoped>
.showMap {
    position: relative;
    #containerMap {
        height: 400px;
        width: 100%;
    }
    .address {
        width: 100%;
        padding: 20px 20px 0;
        font-size: 14px;
        .label {
            color: #666;
            margin: 0 10px;
        }
        .value {
            color: #0286df;
        }
    }
    .inputBox {
        position: absolute;
        top: 40px;
        right: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        #pickerInput {
            width: 300px;
        }
    }
    .LabelBox {
        border: 1px solid #ddd;
        position: absolute;
        z-index: 2;
        bottom: 160px;
        right: 40px;
        background: #ffffff;
        font-size: 14px;
        font-size: 24px;
        cursor: pointer;

        .addressIcon {
            padding: 5px 10px;
            border-bottom: 1px solid #f1f1f1;
            &:nth-child(3) {
                border-bottom: none;
            }
        }
        .UnShow {
            color: #999;
        }
    }
}
</style>
<style lang="scss">
.showMap {
    .el-input.is-disabled .el-input__inner {
        background-color: white !important;
        border-color: white;
        color: #c0c4cc;
    }
    .is-disabled {
        background-color: white!important;
        border-color: white;
        color: #c0c4cc;
        :hover {
            cursor: pointer !important;
        }
    }
}
</style>
